import script from "./CustomTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTextarea.vue?vue&type=script&setup=true&lang=js"

import "./CustomTextarea.vue?vue&type=style&index=0&id=61822bef&lang=css"

const __exports__ = script;

export default __exports__